import { render } from "./EmailWidget.vue?vue&type=template&id=d54695a2&scoped=true"
import script from "./EmailWidget.vue?vue&type=script&lang=js"
export * from "./EmailWidget.vue?vue&type=script&lang=js"

import "./EmailWidget.vue?vue&type=style&index=0&id=d54695a2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d54695a2"]])

export default __exports__